/**
 *
 * Login
 *
 */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { FormattedMessage } from "react-intl";
import { compose } from "redux";
import messages from "./messages";

import { Container, Row } from "reactstrap";
import { Link, Redirect, Route, Switch } from "react-router-dom";
import HomePage from "../Home/Loadable";
import Settings from "../Settings/Loadable";
import Pickups from "../Pickups/Loadable";
import Pickup from "../Pickup/Loadable";
import LoginLayout from "components/LoginLayout";
import LoginForm from "forms/login/";
import { SquareButton } from "../Home";

/* eslint-disable react/prefer-stateless-function */
export class Login extends React.PureComponent {
  render() {
    return (
      <LoginLayout>
        <div>
          <Helmet>
            <title>LoginPage</title>
            <meta name="description" content="Description of LoginPage" />
          </Helmet>
          <div className="center pt-4 pb-5">
            <img
              style={{ maxWidth: "100%" }}
              src={`${
                process.env.REACT_APP_LOGIN_LOGO_URL ||
                process.env.REACT_APP_LOGO_URL
              }`}
            />
            {/*<div className={'p-3'}>*/}
            {/*  <h4>Pickup Donation Login</h4>*/}
            {/*  <i>Login to your account</i>*/}
            {/*</div>*/}
          </div>
          <LoginForm />
        </div>
        <div className={"pt-4"}>
          Don't have an account? <Link to="/create_account">Register</Link>
        </div>
      </LoginLayout>
    );
  }
}

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(null, mapDispatchToProps);

export default compose(withConnect)(Login);
